import { render } from "./PublicProjectCard.vue?vue&type=template&id=49cd0dac&scoped=true"
import script from "./PublicProjectCard.vue?vue&type=script&lang=js"
export * from "./PublicProjectCard.vue?vue&type=script&lang=js"

import "./PublicProjectCard.vue?vue&type=style&index=0&id=49cd0dac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cd0dac"]])

export default __exports__